/** Product labels for Framework Studio — routes and API menu names stay unchanged. */
export const FRAMEWORK_STUDIO_LABELS = {
  sourceDocuments: 'Source Documents',
  sourceDocumentsManageTitle: 'Source Document',
  sourceDocumentsManageDescription:
    'Upload and manage source documents with attachments and reference URLs.',
  sourceDocumentsCreate: 'Upload Document',
  sourceDocumentsEdit: 'Edit Document',
  sourceDocumentsSave: 'Save Document',
  sourceName: 'Source name',
  sourceNamePlaceholder: 'Enter source name',
  sourceType: 'Source type',
  sourceTypePlaceholder: 'Enter new source type',
  sourceTypeSelectPlaceholder: 'Select source type',
  sourceTypeAddNew: 'Add new',
  sourceTypeChooseExisting: 'Choose existing',
  sourceDescriptionPlaceholder: 'Enter source description',
  sourceDetails: 'Source details',
  sourceRecord: 'Source record',
  sourceEmptyList: 'No sources found.',
  capabilityCatalog: 'Capability Catalog',
  capabilityCatalogManageTitle: 'Capability Catalog',
  capabilityCatalogManageDescription:
    'Reference catalog of capabilities and related source document metadata. Use actions to edit or export.',
  assessmentFrameworks: 'Assessment Frameworks',
  assessmentFrameworksListDescription:
    'View and manage Traxccel assessment frameworks. Use Create Framework to select capabilities and build a new one.',
  assessmentFrameworksBuilderDescription:
    'Select capabilities and sub-capabilities from the capability catalog. Included questions are added automatically when you create an assessment framework.',
  createAssessmentFramework: 'Create Assessment Framework',
  createAssessmentFrameworkAction: 'Create Framework',
  readyToCreateAssessmentFramework: 'Ready to create',
  assessmentAssignments: 'Assessment Assignments',
  assessmentAssignmentsDescription:
    'Create project assessments from assessment frameworks with editable question snapshots.',
  createAssessment: 'Create Assessment',
  assessmentFrameworkColumn: 'Assessment Framework',
} as const;
